import { fg } from '@atlassian/jira-feature-gating';

const JscIssueRankingRelayProvider = {
	get(): boolean {
		return fg('jsc_list_reranking_gate');
	},
};

export default JscIssueRankingRelayProvider;
